import { Alert, CollapseProps, Typography } from 'antd'

const { Title } = Typography

export const helpItems: CollapseProps['items'] = [
    {
        key: '1',
        label: <b>Обзор раздела и выбор станка</b>,
        children: (
            <>
                <p>
                    Раздел «Перемотка» — рабочее место перемотчика. Здесь отображается
                    очередь заданий перемотки выбранного станка в том порядке, в котором их
                    распределили в разделе «Перемотка».
                </p>
                <Title level={3}>Выбор станка</Title>
                <p>
                    При входе в раздел показываются карточки станков перемотки. Клик по карточке
                    открывает очередь этого станка, а его название появляется в заголовке страницы.
                </p>
                <Alert
                    showIcon
                    message='Чтобы указать другой станок, выполните вход в систему повторно.'
                    type='info'
                />
            </>
        ),
    },
    {
        key: '2',
        label: <b>Колонки очереди</b>,
        children: (
            <>
                <ul>
                    <li>
                        <b>Номер</b> — номер задания перемотки.
                    </li>
                    <li>
                        <b>Задание печати</b> — номер задания печати, после которого идёт перемотка.
                    </li>
                    <li>
                        <b>Номер отгрузки</b> и <b>Заказчик</b> — из отгрузки.
                    </li>
                    <li>
                        <b>Материал</b> — материал отгрузки.
                    </li>
                    <li>
                        <b>Втулка</b> — втулка, на которую нужно намотать ролики.
                    </li>
                    <li>
                        <b>Ручьи</b> — количество ручьёв.
                    </li>
                    <li>
                        <b>Номер штампа</b> — номер штампа отгрузки.
                    </li>
                    <li>
                        <b>Тираж</b> — суммарный тираж всех видов отгрузки.
                    </li>
                </ul>
            </>
        ),
    },
    {
        key: '3',
        label: <b>Работа с перемоткой</b>,
        children: (
            <>
                <Title level={3}>Начать перемотку</Title>
                <p>
                    Кнопка «Начать перемотку» переводит задание в перемотку и закрепляет его за
                    вами. Кнопка недоступна, пока на станке есть другое незавершённое задание
                    перемотки (в том числе на паузе).
                </p>
                <Title level={3}>Состояния кнопки</Title>
                <ul>
                    <li>
                        <b>Перематывается</b> — задание сейчас перематываете вы.
                    </li>
                    <li>
                        <b>Занято</b> — задание сейчас перематывает другой перемотчик.
                    </li>
                    <li>
                        <b>Пауза</b> и <b>Продолжить перемотку</b> — перемотка задания начата, но
                        сейчас никто её не ведёт (например, после закрытия смены). Продолжить может
                        любой перемотчик.
                    </li>
                </ul>
                <Title level={3}>Завершить</Title>
                <p>В окне завершения выберите вариант:</p>
                <ul>
                    <li>
                        <b>Готово</b> — перемотка выполнена: задание завершается и уходит из очереди
                        станка.
                    </li>
                    <li>
                        <b>Закрытие смены</b> — вы прекращаете работу, задание остаётся в перемотке
                        и встаёт на паузу. Следующий перемотчик продолжит его.
                    </li>
                </ul>
                <Alert
                    showIcon
                    message='После завершения не забудьте отправить фотоотчёт с номером задания в телеграм.'
                    type='info'
                />
                <Title level={3}>Отменить</Title>
                <p>
                    Отменяет задание перемотки и убирает его из очереди станка. Нужно выбрать
                    причину «Другое» и описать её.
                </p>
                <Alert
                    showIcon
                    message='«Завершить» и «Отменить» доступны только перемотчику, который сейчас перематывает это задание.'
                    type='warning'
                />
            </>
        ),
    },
    {
        key: '4',
        label: <b>Подсветка строк и обновление</b>,
        children: (
            <>
                <Title level={3}>Цвет строки</Title>
                <p>
                    <b>Светло-жёлтая</b> строка с тегом «Пауза» — перемотка задания начата, но
                    сейчас её никто не ведёт. Продолжить можно кнопкой «Продолжить перемотку».
                </p>
                <Title level={3}>Обновление</Title>
                <p>
                    Список обновляется автоматически каждые несколько секунд, пока вкладка открыта и
                    активна. Перезагружать страницу не нужно.
                </p>
            </>
        ),
    },
]
